import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { Message, SeverityType } from '../../message';
import { Timer } from '../../timer';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'xrm-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements AfterViewInit, OnDestroy {
  timeout: Timer = null;
  routerEventsSub: Subscription;

  @Input() message: Message;

  @Output() close: EventEmitter<Message> = new EventEmitter<Message>();

  ngOnDestroy() {
    this.clearTimeOut();
    this.routerEventsSub.unsubscribe();
  }

  clearTimeOut() {
    if (this.timeout) {
      // if there is already a timeout in process cancel it
      this.timeout.clear();
      this.timeout = undefined;
    }
  }

  createTimeOut() {
    this.clearTimeOut();
    this.timeout = new Timer(() => {
      this.close.emit(this.message);
    }, this.message.timeout);
  }

  get imageClass() {
    if (this.message) {
      if (this.message.image && this.message.image.length > 0) {
        return this.message.image;
      } else {
        return Message.imageClass(this.message);
      }
    }
  }

  onCloseClick() {
    this.clearTimeOut();
    this.close.emit(this.message);
  }

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: any) {
    if (this.timeout) {
      this.timeout.pause();
    }
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: any) {
    if (this.timeout) {
      this.timeout.resume();
    }
  }

  ngAfterViewInit() {
    if (this.message.closeable && this.message.timeout && this.message.timeout > 0) {
      this.createTimeOut();
    }

    this.routerEventsSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && this.message.closeAfterRouteChange) {
        this.close.emit(this.message);
      }
    });
  }

  constructor(private router: Router) {}
}
